import { Option } from '@/types'
import { defaultLocale, localeOptions } from '@/ts/plugins/i18n.ts'

const state = {
  languageSelect: {
    options: [] as Option[],
    value: defaultLocale,
  },
}

const getters = {
  selectedLanguage: state => state.languageSelect.value
}

const mutations = {
  changeSelectedLanguage(state, language) {
    state.languageSelect.value = language
  },
  setLanguageSelectOptions(state,locales){
    state.languageSelect.options = locales;
  }
}

const actions = {
  updateLanguageSelectOptions({ commit }, locales){
    const filteredLocales = Array.isArray(locales) && locales.length 
    ? locales 
    : localeOptions;

    commit('setLanguageSelectOptions',filteredLocales)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
